import { render, staticRenderFns } from "./new_artical.vue?vue&type=template&id=1280db0f&scoped=true"
import script from "./new_artical.vue?vue&type=script&lang=js"
export * from "./new_artical.vue?vue&type=script&lang=js"
import style0 from "./new_artical.vue?vue&type=style&index=0&id=1280db0f&prod&scoped=true&lang=scss"
import style1 from "./new_artical.vue?vue&type=style&index=1&id=1280db0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280db0f",
  null
  
)

export default component.exports